import React from "react";
import { Box, Typography, Chip } from "@mui/material";

const FlowProgress = ({ currentPage, variant = "compact" }) => {
  const steps = [
    {
      id: "knowledge-base",
      title: "Knowledge Base",
      icon: "📚",
      description: "Add your content",
    },
    {
      id: "channels",
      title: "Channels",
      icon: "💬",
      description: "Choose how users chat",
    },
    {
      id: "actions",
      title: "Integrations",
      icon: "🔧",
      description: "Connect tools",
    },
    {
      id: "agent",
      title: "Create Agent",
      icon: "🤖",
      description: "Deploy your AI",
    },
  ];

  const getStepStatus = (step) => {
    if (step.id === currentPage) {
      return "active";
    }
    return "pending";
  };

  if (variant === "compact") {
    return (
      <Box
        sx={{
          mb: 3,
          p: 3,
          backgroundColor: "white",
          borderRadius: 3,
          border: "1px solid #e2e8f0",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#1e293b",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            🚀 Agent Builder Flow
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <Chip
                label={`${step.icon} ${step.title}`}
                variant={
                  getStepStatus(step) === "active" ? "filled" : "outlined"
                }
                color={getStepStatus(step) === "active" ? "primary" : "default"}
                size="medium"
                sx={{
                  fontSize: "0.875rem",
                  height: 36,
                  ...(getStepStatus(step) === "active" && {
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    fontWeight: 600,
                    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
                  }),
                  ...(getStepStatus(step) !== "active" && {
                    backgroundColor: "#f8fafc",
                    borderColor: "#e2e8f0",
                    color: "#64748b",
                    "&:hover": {
                      backgroundColor: "#f1f5f9",
                    },
                  }),
                }}
              />
              {index < steps.length - 1 && (
                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{
                    mx: 1,
                    color: "#cbd5e1",
                    fontWeight: 300,
                  }}
                >
                  →
                </Typography>
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Agent Builder Flow
      </Typography>

      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 2,
                borderRadius: 2,
                border:
                  getStepStatus(step) === "active"
                    ? "2px solid #667eea"
                    : "1px solid #e2e8f0",
                backgroundColor:
                  getStepStatus(step) === "active" ? "#f0f4ff" : "white",
                minWidth: 120,
              }}
            >
              <Typography variant="h4" sx={{ mb: 1 }}>
                {step.icon}
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, textAlign: "center" }}
              >
                {step.title}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ textAlign: "center" }}
              >
                {step.description}
              </Typography>
            </Box>
            {index < steps.length - 1 && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h6" color="text.secondary">
                  →
                </Typography>
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default FlowProgress;
